// Note-overlap rules: your note may live anywhere on the infinite
// board, but never on top of someone else's. Axis-aligned,
// centre-based rects (rotation is small enough to ignore).

export interface Rect {
  x: number; // centre
  y: number;
  w: number;
  h: number;
}

export const MARGIN = 12;

/** Penetration depths if the rects (plus margin) overlap, else null. */
export function overlap(a: Rect, b: Rect, margin = MARGIN): { dx: number; dy: number } | null {
  const dx = (a.w + b.w) / 2 + margin - Math.abs(a.x - b.x);
  const dy = (a.h + b.h) / 2 + margin - Math.abs(a.y - b.y);
  return dx > 0 && dy > 0 ? { dx, dy } : null;
}

export const collides = (me: Rect, obstacles: Rect[]): boolean =>
  obstacles.some((o) => overlap(me, o) !== null);

/** Push `me` out of any obstacles along the cheapest axis until clear. */
export function resolve(me: Rect, obstacles: Rect[], maxIter = 40): { x: number; y: number } {
  const r = { ...me };
  for (let i = 0; i < maxIter; i++) {
    const hit = obstacles.map((o) => ({ o, v: overlap(r, o) })).find((h) => h.v);
    if (!hit || !hit.v) break;
    const { o, v } = hit;
    if (v.dx < v.dy) r.x += r.x >= o.x ? v.dx : -v.dx;
    else r.y += r.y >= o.y ? v.dy : -v.dy;
  }
  return { x: Math.round(r.x), y: Math.round(r.y) };
}
